import { render, staticRenderFns } from "./caririskRaporuBakiyeRenderer.vue?vue&type=template&id=57b4c132&"
import script from "./caririskRaporuBakiyeRenderer.vue?vue&type=script&lang=js&"
export * from "./caririskRaporuBakiyeRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports